export default {
  originCity: 'Vælg afrejseby',
  destinationCity: 'Vælg ankomst by',
  direct: 'Direkte',
  indirect: '1+ omstigning',
  getPrices: 'Få priser',
  directAvailable: 'Direkte tilgængelig fra',
}
